import Axios from "axios";
import {
    SET_DOCUMENTS_STARRED_LIST,
    UNSET_DOCUMENTS_STARRED_LIST,
} from "@/store/mutation-types";

import { 
    getStarredDocumentsList,
    saveStarredDocuments
} from "@/store/api";

const state = {
    getStarredDocumentsList: [],
};

const getters = {
    getStarredDocumentsList(state) {
        return state.getStarredDocumentsList;
    },
};

const mutations = {
    [SET_DOCUMENTS_STARRED_LIST](state, data) {
        state.getStarredDocumentsList = data;
    },
    [UNSET_DOCUMENTS_STARRED_LIST](state) {
        state.getStarredDocumentsList = [];
    },
};

const actions = {
    getStarredDocumentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {color: "primary"});
            Axios.get(getStarredDocumentsList, { params: data})
                .then(function (response) {
                    commit('SET_DOCUMENTS_STARRED_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_DOCUMENTS_STARRED_LIST')
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING")
                });
        });
    },

    saveStarredDocuments({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveStarredDocuments, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

};

export default {
    state,
    getters,
    actions,
    mutations,
};
